import React from "react";
import ReactDOM from "react-dom";
import { Section, Box, Heading, Paragraph, Image } from "grommet";

import titleImage from "./title.jpg";
import screenshot from "./screenshot.jpg";

const EnergyBars = props => (
  <Section colorIndex={props.colorIndex} pad="medium" align="center">
    {!props.responsive ? (
      <Heading tag="h2" strong={true} margin="small">
        MOBA Style Energy Bars
      </Heading>
    ) : null}
    <Box direction="row" size={{ width: "xxlarge" }}>
      <Box direction="column" basis="2/3" margin="small" textAlign="left">
        <Image src={titleImage} size="large" />
        <Paragraph>
          MOBA Style Energy Bars is another Unity asset that I've made and sell
          on the Unity asset store. It implements an energy bar which displays
          discrete cells so there's a visual indication for how many points the
          energy bar contains. This style of energy bar is found in a lot of
          games and especially in many MOBA type games.
        </Paragraph>
        <Paragraph>
          Each energy bar is implemented as a single hlsl shader on a quad. All
          of the cell boundaries are rendered in this shader program. This
          implementation is much simpler then creating the cells by overlaying
          sprite images, but special care had to be made to handle aliasing.
        </Paragraph>
      </Box>
      <Box direction="column" basis="1/3" justify="left" textAlign="left">
        <Paragraph>
          The package also includes some premade health bars with components to
          attach them to characters and follow them on screen. A customer can
          buy this package and have a working health bar immediately.
        </Paragraph>
        <Image src={screenshot} size="medium" />
        <Paragraph>
          MOBA Style Energy Bars has maintained a 5 star average on the asset
          store and has plenty of happy customers.
        </Paragraph>

        <Paragraph size="small">
          If you'd like to know more you can go to the store page{" "}
          <a href="https://assetstore.unity.com/packages/tools/gui/moba-style-energy-bars-66190">
            here
          </a>
        </Paragraph>
      </Box>
    </Box>
  </Section>
);

export default EnergyBars;



// WEBPACK FOOTER //
// ./src/components/projects/energy-bars/energy-bars.js